import React from "react";

export default function PageLayout({ children }) {
  return (
    <div style={{ padding: 20, background: "#121212", minHeight: "100vh", color: "#fff" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>{children}</div>
    </div>
  );
}
